// ─────────────────────────────────────────────────────────────
// NoFeaturedPreacherBanner — red top banner that warns the
// publisher when no published preacher song is currently
// flagged as the Preach Mode feature card.
//
// Mirrors the OpenDAW CORE UpdateMessage pattern. Self-mounts.
// Re-checks every 60s and after each publish so it disappears
// the moment a featured card is set.
// ─────────────────────────────────────────────────────────────

import css from "./NoFeaturedPreacherBanner.sass?inline"
import {Html} from "@opendaw/lib-dom"
import {createElement} from "@opendaw/lib-jsx"
import {STApi} from "@/jerry/st-panel/STApi"

const className = Html.adoptStyleSheet(css, "NoFeaturedPreacherBanner")
const REFRESH_INTERVAL_MS = 60_000

let bannerEl: HTMLElement | null = null
let pollTimer: ReturnType<typeof setInterval> | null = null

const render = (): HTMLElement => (
    <div className={className}>
        No Preach Mode feature card set — flag a published preacher song to enable the card.
    </div>
)

const sync = async (): Promise<void> => {
    let hasFeatured = false
    try {
        const songs = await STApi.getSongs({status: "published"})
        hasFeatured = songs.some(
            (song) => song.playerType === "preacher" && song.isPreachModeFeatured === true,
        )
    } catch (err) {
        console.warn("[NoFeaturedPreacherBanner] sync failed:", err)
        return
    }
    if (hasFeatured && bannerEl) {
        bannerEl.remove()
        bannerEl = null
        return
    }
    if (!hasFeatured && !bannerEl) {
        bannerEl = render()
        document.body.prepend(bannerEl)
    }
}

export namespace NoFeaturedPreacherBanner {
    export const init = (): void => {
        void sync()
        if (pollTimer === null) {
            pollTimer = setInterval(() => void sync(), REFRESH_INTERVAL_MS)
        }
        document.addEventListener("st:published", () => void sync())
    }
}
